import React from 'react';
import { VStack } from '@chakra-ui/react';
export const ModalSectionContainer = (props) => (React.createElement(VStack, { w: "100%" }, props.children));
